(() => {
  if (window.__zaaishaSortBound) return;
  window.__zaaishaSortBound = true;

  const closeAll = (except) => {
    document.querySelectorAll('[data-zaaisha-sort].is-open').forEach((root) => {
      if (except && root === except) return;
      root.classList.remove('is-open');
      const trigger = root.querySelector('[data-zaaisha-sort-trigger]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener(
    'click',
    (event) => {
      const option = event.target.closest('[data-zaaisha-sort-option]');
      if (option) {
        event.preventDefault();
        event.stopPropagation();
        const root = option.closest('[data-zaaisha-sort]');
        if (!root) return;
        const select = root.querySelector('select.zaaisha-sort__native');
        const valueEl = root.querySelector('[data-zaaisha-sort-value]');
        const value = option.getAttribute('data-value');
        if (select && value != null) {
          select.value = value;
          if (valueEl) valueEl.textContent = option.textContent.trim();
          root.querySelectorAll('[data-zaaisha-sort-option]').forEach((btn) => {
            const selected = btn === option;
            btn.classList.toggle('is-selected', selected);
            btn.setAttribute('aria-selected', selected ? 'true' : 'false');
          });
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        closeAll();
        return;
      }

      const trigger = event.target.closest('[data-zaaisha-sort-trigger]');
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        const root = trigger.closest('[data-zaaisha-sort]');
        if (!root) return;
        const willOpen = !root.classList.contains('is-open');
        closeAll();
        if (willOpen) {
          root.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
        return;
      }

      if (!event.target.closest('[data-zaaisha-sort]')) closeAll();
    },
    true
  );

  document.addEventListener('keyup', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
